import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Chip,TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import '../ticketKnowledge/DrilldownAndDetailSearch.css';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { I18n } from 'aws-amplify';
import _ from 'lodash';
import AlertSettingPermission from './AlertSettingPermission';
import { getListActiveB2BCustomerSelector, getListActiveB2BHelpdeskSelector } from '@/state/selector/ticketSelector';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { checkDisplayCreateTicketForOwnerAdditionalPermission } from './handler/FormListHandler';
import organizationService from '@/service/organizationService';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';

export default function SettingCreateTicketForOwnerPermission({ props, argsAll }) {
    const [createTicketForOwnerPermissionList, setCreateTicketForOwnerPermissionList] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const listB2BCustomerRecoilState = useRecoilValue(getListActiveB2BCustomerSelector);
    const listB2BHelpDeskRecoilState = useRecoilValue(getListActiveB2BHelpdeskSelector);
    const listProjectInOrg = useRecoilValue(projectListInCorporationAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [listAdditionalPermissionOption, setListAdditionalPermissionOption] = useState([]);
    const [isDisplayAdditionalPermission,setIsDisplayAdditionalPermission] = useState(true);

    const knowledgeFormCreateTicketForOwnerPermissions = Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT;

    const filterAdditionalPermissionListOption = listOption => {
        let listOptionAfterFilter = listOption;

        const createTicketForOwnerPermission = argsAll.createTicketForOwnerBasePermission;
        const baseCreateTicketForOwnerPermissionObject = Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT;

        const baseCreateTicketForOwnerPermission = Object.keys(baseCreateTicketForOwnerPermissionObject).filter(key => 
            createTicketForOwnerPermission.includes(baseCreateTicketForOwnerPermissionObject[key])
        );
        
        if(baseCreateTicketForOwnerPermission.includes('ALL_ORG')){
            return []
        }

        if(baseCreateTicketForOwnerPermission.includes('B2B_CUSTOMER')){
            listOptionAfterFilter = listOptionAfterFilter?.filter(option =>{
                return option.groupLabel !== 'B2Bカスタマープロジェクト'
            })
        }

        if(baseCreateTicketForOwnerPermission.includes('B2B_SUPPORT')){
            listOptionAfterFilter = listOptionAfterFilter?.filter(option =>{
                return option.groupLabel !== 'B2Bサポートプロジェクト'
            })
        }

        if(baseCreateTicketForOwnerPermission.includes('IN_ORG')){
            listOptionAfterFilter = listOptionAfterFilter?.filter(option =>{
                return option.groupLabel !== '組織内の特定プロジェクト'
            })
        }
       return listOptionAfterFilter
    };

    const onChangeSelectedBasePermission = (event,value) => {
        argsAll.setCreateTicketForOwnerBasePermission([...value]);
       
        if (value.length > 0) {
            argsAll.setIsChangeData(true);
        } else {
            argsAll.setIsChangeData(false);
        }
        argsAll.setAdditionalCreateTicketForOwnerPermission([])
    };

    const onChangeSelectedAdditionalPermission = (event,value) => {
        
        argsAll.setAdditionalCreateTicketForOwnerPermission([...value]);
       
        if (value.length > 0) {
            argsAll.setIsChangeData(true);
        } else {
            argsAll.setIsChangeData(false);
        }
    };

    const filterSuggestionBasePermissionOption = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${option}`
    });

    const filterSuggestionAdditionalPermissionOption = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${option.label}`
    });

    const handleDeleteBasePermission = selectedOption => {
        let newSPermissions = argsAll.createTicketForOwnerBasePermission.filter(option => {
            return option !== selectedOption;
        });
        
        argsAll.setCreateTicketForOwnerBasePermission([...newSPermissions]);
        argsAll.setIsChangeData(true);
        if (newSPermissions.length === 0) argsAll.setIsChangeData(false);
        argsAll.setAdditionalCreateTicketForOwnerPermission([])
    };

    // handle delete additional create ticket for owner permission
    const handleDeleteAdditionalPermission = selectedOption => {
        let newSPermissions = argsAll?.additionalCreateTicketForOwnerPermission?.filter(option => {
            return option.id !== selectedOption.id || option.groupLabel !== selectedOption.groupLabel;
        });

        argsAll.setAdditionalCreateTicketForOwnerPermission([...newSPermissions]);
        argsAll.setIsChangeData(true);
    };

    const getOptionOfAdditionalPermission = () => {
        const b2bCustomerList = argsAll?.b2bCustomerList;
        const b2bHelpDeskList = argsAll?.b2bHelpDeskList;
        let b2bCustomerOptionList = [];
        let b2bHelpDeskOptionList = [];
        let otherProjectInOrgOptionList = [];

        //get list option b2b customer
        listB2BCustomerRecoilState?.forEach( async (project) => {
            if(project.active !== Constant.ACTIVE_FLAG.DELETED) {

                let nameOfProject = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,project.name);
                let organizationOfProject = b2bCustomerList?.find(org => org.id === project.affiliationOrganization )

                //if org not found
                if(Utils.isEmptyObject(organizationOfProject)){
                    organizationOfProject = await organizationService.getCorporationById(props?.API,project.affiliationOrganization);
                    organizationOfProject.title = Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP,organizationOfProject)
                }

                if(organizationOfProject?.active && organizationOfProject?.active !== Constant.CORPORATION_ACTIVE.ACTIVE) return ;

                let labelOfOption = `${nameOfProject} (${organizationOfProject?.title})`
                let option = {
                    label: labelOfOption,
                    id: project.id,
                    groupLabel: 'B2Bカスタマープロジェクト'
                }

                b2bCustomerOptionList.push(option)
            }
        });

        // get list option b2b help desk
        listB2BHelpDeskRecoilState?.forEach(async (project) => {
            if(project.active !== Constant.ACTIVE_FLAG.DELETED) {
                let nameOfProject = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,project.name);
                let organizationOfProject = b2bHelpDeskList?.find(org => org.id === project.affiliationOrganization )

                if(Utils.isEmptyObject(organizationOfProject)){
                    organizationOfProject = await organizationService.getCorporationById(props?.API,project.affiliationOrganization);
                    organizationOfProject.title = Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP,organizationOfProject)
                }

                if(organizationOfProject?.active && organizationOfProject?.active !== Constant.CORPORATION_ACTIVE.ACTIVE) return ;

                let labelOfOption = `${nameOfProject} (${organizationOfProject?.title})`
                let option = {
                    label: labelOfOption,
                    id: project.id,
                    groupLabel: 'B2Bサポートプロジェクト'
                }

                b2bHelpDeskOptionList.push(option)
            }
        });

        
        // get list option other project in org
        listProjectInOrg?.forEach((project) =>{
            if(project.id !== projectInuseDetail.id && ![Constant.PROJECT_TYPE.BASE,Constant.PROJECT_TYPE.CUSTOMER].includes(project.type) && project.active !== Constant.ACTIVE_FLAG.DELETED){
                let labelOfOption =  Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,project.name);
                let option = {
                    label: labelOfOption,
                    id: project.id,
                    groupLabel: '組織内の特定プロジェクト'
                }

                otherProjectInOrgOptionList.push(option)
            }
        });
        otherProjectInOrgOptionList = Utils.sortListByLabelDictionaryASC(otherProjectInOrgOptionList)
        b2bCustomerOptionList = Utils.sortListByLabelDictionaryASC(b2bCustomerOptionList)
        b2bHelpDeskOptionList = Utils.sortListByLabelDictionaryASC(b2bHelpDeskOptionList)
        setListAdditionalPermissionOption([...otherProjectInOrgOptionList,...b2bCustomerOptionList,...b2bHelpDeskOptionList])
    };

    const prepareListSelectedOptionAdditionalPermission = (selectedAdditionalPermissions) => {

        let selectedAdditionalPermissionsOption = [];

        selectedAdditionalPermissions.forEach((projectId) => {
            const selectedOption = listAdditionalPermissionOption?.find((option)=>{
                const isExistSelectedOption = checkIncludeAdditionalPermissionOption(selectedAdditionalPermissionsOption,option)
                return option.id === projectId && !isExistSelectedOption
            })

            if(!Utils.isEmptyObject(selectedOption))  selectedAdditionalPermissionsOption.push(selectedOption)
        });

        return selectedAdditionalPermissionsOption;

    };

    const checkIncludeAdditionalPermissionOption = (selectedAdditionalPermissionsOption,selectOption) => {
        const result = selectedAdditionalPermissionsOption.find((option) => {
            return option.id === selectOption.id && option.groupLabel === selectOption.groupLabel
        });

        return !Utils.isEmptyObject(result)
    }

    useEffect(() => {
        const optionViewPermissionList = Object.keys(
            knowledgeFormCreateTicketForOwnerPermissions
        )?.map(key => knowledgeFormCreateTicketForOwnerPermissions[key]);
        setCreateTicketForOwnerPermissionList([...optionViewPermissionList]);
    
        if (argsAll.formEdit) {
            let selectedBasePermissions = [];
            if (!Utils.isEmptyArray(argsAll?.formEdit?.createTicketForOwnerPermission)) {
                selectedBasePermissions = argsAll?.formEdit?.createTicketForOwnerPermission?.map(
                    key => knowledgeFormCreateTicketForOwnerPermissions[key]
                );
            }
            if (Utils.isEmptyArray(selectedBasePermissions)) {
                argsAll.setCreateTicketForOwnerBasePermission([Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT.IN_PROJECT]);
            } else {
                argsAll.setCreateTicketForOwnerBasePermission([...selectedBasePermissions]);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(()=>{
      getOptionOfAdditionalPermission()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[listProjectInOrg,listB2BCustomerRecoilState,listB2BHelpDeskRecoilState]);

    useEffect(() =>{
        if (argsAll.formEdit) {
            let selectedAdditionalPermissionsOption = [];
            if (!Utils.isEmptyArray(argsAll?.formEdit?.additionalCreateTicketForOwnerPermission)) {
               const selectedAdditionalPermissions = argsAll?.formEdit?.additionalCreateTicketForOwnerPermission;
               selectedAdditionalPermissionsOption = prepareListSelectedOptionAdditionalPermission(selectedAdditionalPermissions)
            }
            if (Utils.isEmptyArray(selectedAdditionalPermissionsOption)) {
                argsAll.setAdditionalCreateTicketForOwnerPermission([]);
            } else {
                argsAll.setAdditionalCreateTicketForOwnerPermission([...selectedAdditionalPermissionsOption]);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[listAdditionalPermissionOption]);

    // check display additional permission
    useEffect(() => {
        const isDisplay = checkDisplayCreateTicketForOwnerAdditionalPermission(argsAll.createTicketForOwnerBasePermission);
        setIsDisplayAdditionalPermission(isDisplay);
    }, [argsAll.createTicketForOwnerBasePermission]);



    return (
        <>
            <div className="lstCreateForm padding-0">
                <label className="share-option-text">基本投稿権限</label>
                <div className="share-option-control">
                    <Autocomplete
                        className="search-option-tag-content"
                        multiple
                        filterSelectedOptions
                        filterOptions={filterSuggestionBasePermissionOption}
                        getOptionLabel={option => option}
                        options={createTicketForOwnerPermissionList}
                        value={argsAll.createTicketForOwnerBasePermission}
                        onChange={onChangeSelectedBasePermission}
                        disabled={argsAll.isFormReadOnly || (argsAll.isDisplaySettingSynonymSearch(argsAll.corporationDetail, argsAll?.formEdit?.type || argsAll?.addFormType , argsAll.projectDetail) && argsAll.isSynonym)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                variant="outlined"
                                className="form-control"
                                onKeyDown={event => {
                                    if (event.key === 'Backspace') event.stopPropagation();
                                }}
                            />
                        )}
                        renderTags={valueTag => {                           
                            return valueTag.map((selectedOption, index) => {
                                if (
                                    selectedOption ===
                                    Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT
                                        .IN_PROJECT
                                ) {
                                    return (
                                        <Chip
                                            label={selectedOption}
                                            className="MuiChip-root setting-title"
                                        />
                                    );
                                } else {
                                    return (
                                        <Chip
                                            label={selectedOption}
                                            className="MuiChip-root setting-title"
                                            onDelete={e => {
                                                handleDeleteBasePermission(selectedOption);
                                            }}
                                        />
                                    );
                                }
                            });
                        }}
                        ListboxProps={{
                            style: {
                                maxHeight: 376,
                                overflow: 'auto',
                                overflowX: 'hidden'
                            }
                        }}
                        noOptionsText={I18n.get('COMMSG001')}
                    />
                    <AlertSettingPermission isOpen={isAlertOpen} setIsOpen={setIsAlertOpen} />
                </div>
            </div>
            {(isDisplayAdditionalPermission && !(argsAll.isDisplaySettingSynonymSearch(argsAll.corporationDetail,argsAll?.formEdit?.type || argsAll?.addFormType, argsAll.projectDetail) && argsAll.isSynonym)) && (
                <div className="lstCreateForm padding-0">
                    <label className="share-option-text">追加投稿権限</label>
                    <div className="share-option-control">
                        {!argsAll.isFormReadOnly ? (
                            <Autocomplete
                                className="search-option-tag-content"
                                multiple
                                filterSelectedOptions
                                filterOptions={filterSuggestionAdditionalPermissionOption}
                                getOptionLabel={option => option.label}
                                options={filterAdditionalPermissionListOption(
                                    listAdditionalPermissionOption
                                )}
                                value={argsAll.additionalCreateTicketForOwnerPermission}
                                getOptionSelected={(option, value) => option.id === value.id && option.groupLabel ===value.groupLabel}
                                onChange={onChangeSelectedAdditionalPermission}
                                groupBy={option => option.groupLabel}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        className="form-control"
                                        onKeyDown={event => {
                                            if (event.key === 'Backspace') event.stopPropagation();
                                        }}
                                    />
                                )}
                                renderTags={valueTag => {                                  
                                    return valueTag.map((selectedOption, index) => {
                                        return (
                                            <Chip
                                                label={<OverFlowTooltipWithTabsMui value={selectedOption.label} className="max-w-370"/>}
                                                className="MuiChip-root setting-title"
                                                onDelete={e => {
                                                    handleDeleteAdditionalPermission(
                                                        selectedOption
                                                    );
                                                }}
                                            />
                                        );
                                    });
                                }}
                                ListboxProps={{
                                    style: {
                                        maxHeight: 376,
                                        overflow: 'auto',
                                        overflowX: 'hidden'
                                    }
                                }}
                                noOptionsText={I18n.get('COMMSG001')}
                            />
                        ) : (
                            <TextField
                                className="form-input-outlined form-control-wrapInput"
                                variant="outlined"
                                disabled
                            />
                        )}
                    </div>
                </div>
            )}
        </>
    );
}
